import Stack from "@mui/material/Stack";
import { datatypes } from "data/globalData";
import { grey } from "@mui/material/colors";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import NumberTextField from "components/ReusableComponents/NumberTextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const CustomTextField = ({ data, setData, column, width, required, type, sx, disabled, onChange, disableLabel, variant, minDateTime }) => {
	return (
		<Stack sx={{ width }} spacing={"3px"} height={disableLabel ? "40px" : "70px"}>
			{!disableLabel && (
				<InputLabel sx={{ color: grey[600] }}>
					{column?.name}
					{required && <span style={{ color: "red" }}>*</span>}
				</InputLabel>
			)}

			{/* Number Field */}
			{column?.data_type === datatypes.NUMBER.key ? (
				<NumberTextField
					size="small"
					fullWidth
					variant={variant || "standard"}
					sx={sx}
					disableHelperText
					disabled={disabled}
					onChange={onChange}
					value={data?.[column.key] || 0}
					placeholder={column?.placeholder || ""}
				/>
			) : column?.data_type === datatypes.DATE_TIMESTAMP.key ? (
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<DateTimePicker
						value={data?.[column.key] || null}
						onChange={onChange}
						disabled={disabled}
						// disablePast
  						minDateTime={minDateTime ? minDateTime : new Date()}
						slotProps={{
							textField: {
								variant: variant || "standard",
								size: "small",
								sx,
								fullWidth: true,
								required,
							},
						}}
					/>
				</LocalizationProvider>
			) : (
				<TextField
					variant={variant || "standard"}
					sx={sx}
					size="small"
					type={datatypes[column?.data_type]?.htmlVar || "text"}
					value={data?.[column.key] || ""}
					onChange={onChange}
					disabled={disabled}
					placeholder={column?.placeholder || `Enter ${column?.key}`}
					required={!!required}
					fullWidth
				/>
			)}
		</Stack>
	);
};

export default CustomTextField;
